(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const sliders = new WeakSet();

    const getActiveIndex = (track) => {
      const width = track.clientWidth;

      if (width === 0) {
        return 0;
      }

      return Math.round(track.scrollLeft / width);
    };

    const updateSlider = (slider) => {
      const track = slider.querySelector('[data-product-card-slider-track]');
      const slides = slider.querySelectorAll('[data-product-card-slider-slide]');
      const dots = slider.querySelectorAll('[data-product-card-slider-dot]');
      const previousButton = slider.querySelector('[data-product-card-slider-previous]');
      const nextButton = slider.querySelector('[data-product-card-slider-next]');

      if (!track || slides.length < 2) {
        return;
      }

      const activeIndex = Math.max(0, Math.min(getActiveIndex(track), slides.length - 1));

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });

      previousButton?.toggleAttribute('disabled', activeIndex === 0);
      nextButton?.toggleAttribute('disabled', activeIndex === slides.length - 1);
    };

    const initializeSlider = (slider) => {
      if (sliders.has(slider)) {
        return;
      }

      const track = slider.querySelector('[data-product-card-slider-track]');

      if (!track) {
        return;
      }

      sliders.add(slider);

      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(() => updateSlider(slider));
      }, { passive: true });

      updateSlider(slider);
    };

    const initializeAllSliders = () => {
      document.querySelectorAll('[data-product-card-slider]').forEach(initializeSlider);
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-product-card-slider-previous], [data-product-card-slider-next]');

      if (!button) {
        return;
      }

      const slider = button.closest('[data-product-card-slider]');
      const track = slider?.querySelector('[data-product-card-slider-track]');

      if (!track) {
        return;
      }

      event.preventDefault();

      const direction = button.hasAttribute('data-product-card-slider-next') ? 1 : -1;
      track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    });

    document.addEventListener('DOMContentLoaded', initializeAllSliders);
    document.addEventListener('shopify:section:load', initializeAllSliders);
    initializeAllSliders();
  })();
  } catch(e) { console.error(e); }
})();

})();
